import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAwesomelistsComponent } from './simple-icons-awesomelists.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAwesomelistsComponent ],
    exports:      [ SimpleIconsAwesomelistsComponent ],
    bootstrap:    []
})
export class SimpleIconsAwesomelistsModule {}
